import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const ColorSeriesPage = () => {
  const [colorSeries, setColorSeries] = useState([]);

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + `/api/color-series`)
      .then((response) => response.json())
      .then((data) => setColorSeries(data))
      .catch((error) => console.error("Error fetching color series:", error));
  }, []);

  return (
    <div className="container mx-auto py-24">
      <h1 className="text-4xl font-bold mb-8 text-center">嚴選色系</h1>
      <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {colorSeries.map((series) => (
          <li
            key={series.id}
            className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
          >
            <Link
              to={`/color-series/${series.id}`}
              className="text-xl font-semibold text-gray-800 hover:text-gray-600"
            >
              {series.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ColorSeriesPage;
